package one.healthium.rateus.di

import one.healthium.rateus.data.AppRateManager
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val rateUsModule = module {
    singleOf(::AppRateManager)
}